//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import navs from "./nav/index";
import list from "./list/index";
import maps from "./list/map";
import db from "./list/db";
import Vue from 'vue';
export default {
  components: {
    navs: navs,
    list: list,
    maps: maps,
    db: db
  },
  data: function data() {
    return {
      activeName: 0
    };
  },
  beforeCreate: function beforeCreate() {
    window.$website = {
      url: window.domainURL,
      isDemo: false,
      isDemoTip: '演示环境不允许操作'
    };
    Vue.prototype.$website = window.$website;
  },
  methods: {
    handleChange: function handleChange(nav, index) {
      this.activeName = index;
      console.log('activeName', this.activeName);
    }
  }
};